/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { AbsenteeismDropdown } from "./AbsenteeismDropdown";

export const AbsenteeismColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { options, absenteeismValues, setAbsenteeismValues }
) => (
  <AbsenteeismDropdown
    id={row.id}
    options={options}
    parentId={row.parentId}
    studentName={row.studentName}
    absenteeismValues={absenteeismValues}
    setAbsenteeismValues={setAbsenteeismValues}
  />
);